import { fetchHuggg, getHuggg } from 'redux/modules/huggg';
import { fetchTerms, getTerms, getTermsError } from 'redux/modules/brand';

import { CMSContent } from 'components/misc';
import { connect } from 'react-redux';
import dictionary from 'config/dictionary';

const mapStateToProps = state => ({
  content: getTerms(state),
  error: getTermsError(state),
  huggg: getHuggg(state),
  title: dictionary.brandTermsTitle
});

export default connect(
  mapStateToProps,
  { fetchContent: fetchTerms, fetchHuggg }
)(CMSContent);
